var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{class:_vm.$vuetify.theme.dark ? 'blue-darken-2 ' : 'white-lighten-5'},[_c('v-row',{staticClass:"pt-5"},[_c('v-col',{staticClass:"pb-0",attrs:{"cols":"12","lg":"7"}},[_c('UploadedBanner')],1),_c('v-col',{staticClass:"pb-0",attrs:{"cols":"12","lg":"5"}},[_c('BannerSize')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }